import gql from "graphql-tag";
import WORKFLOWABLE_FRAGMENT from "@/graphql/fragments/workflowable";
import WORKFLOW_STATUS_FRAGMENT from "@/graphql/fragments/workflow_status";
import ATTENDANCE_PLACE_FRAGMENT from "@/graphql/fragments/attendance_place";

export default gql`
  query medicalRequest($medicalRequestId: ID!) {
    medicalRequest(medicalRequestId: $medicalRequestId) {
      id
      observation
      site
      createdAt
      executedAt
      medicalRequestType
      reason
      requestedQuantity
      emergency
      requestNumber
      ${WORKFLOWABLE_FRAGMENT}
      requester {
        id
        employee {
          id
          name
        }
      }
      forwardTo {
        id
        employee {
          id
          name
        }
      }
      
      cid {
        id
        code
        description
        codeDescription
      }
      medicalRequestItem {
        id
        name
        medicalRequestType
      }
    }
  }

  ${WORKFLOW_STATUS_FRAGMENT}
  ${ATTENDANCE_PLACE_FRAGMENT}
`;
